// Откуда пришёл фокус (044, MOT-13, MOT-14, research Р3): подсказка открывается от фокуса, который
// человек перевёл клавишами навигации, а не от фокуса, который поставила программа: при открытии
// окна, панели, меню и при возврате фокуса после закрытия слоя. :focus-visible здесь не годится:
// после Esc браузер считает возврат фокуса «клавиатурным», и подсказка всплыла бы над кнопкой,
// куда вернулся фокус (ревью 04.11.2026, находка 7).

/** Клавиши, которыми человек сам ведёт фокус: Tab, Shift+Tab, стрелки, Home, End. */
const NAVIGATION_KEYS = new Set([
  'Tab',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
]);

/** Фокус «того же нажатия»: не позже этого срока после клавиши. */
const SAME_PRESS_MS = 100;

let lastKey: { key: string; at: number } | null = null;

function now(): number {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
}

// Слушатель на window с захватом: клавишу видно раньше, чем её обработает страница или слой,
// который переведёт фокус. Нажатие указателя сбрасывает клавишу: фокус от щелчка — не с клавиатуры.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'keydown',
    (event) => {
      lastKey = { key: event.key, at: now() };
    },
    true,
  );
  window.addEventListener(
    'pointerdown',
    () => {
      lastKey = null;
    },
    true,
  );
}

/**
 * Фокус перевёл человек: последнее нажатие — Tab, Shift+Tab, стрелка, Home или End, и оно было
 * не раньше 100 мс назад. Фокус после Esc и Enter (закрытие слоя, действие) — программный.
 */
export function focusFromNavigation(): boolean {
  return (
    lastKey !== null && NAVIGATION_KEYS.has(lastKey.key) && now() - lastKey.at <= SAME_PRESS_MS
  );
}
